import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SOLICITUD_CONGELAMIENTO_SALDO_RESPONSE, VOUCHER_PAGE_PROPERTIES } from '@constants/congelamiento-saldo';
import { ROUTING_CONGELAMIENTOS_SALDOS } from '@constants/url.constant';
import { ISolicitudResponse } from '@interfaces/solicitud-cambio-via-pago.response.interface';
import { VoucherProperties } from '@interfaces/voucher-properties.interface';
import { StorageService } from '@services/storage/storage.service';

@Component({
    selector: 'app-congelamiento-saldos-comprobante',
    templateUrl: './congelamiento-saldos-comprobante.component.html',
    styleUrls: ['./congelamiento-saldos-comprobante.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CongelamientoSaldosComprobanteComponent implements OnInit {

  public voucherProperties: VoucherProperties = VOUCHER_PAGE_PROPERTIES;
  public solicitudResponse: ISolicitudResponse;
  public loading: boolean = false;

  constructor( private readonly router: Router,private readonly storageService: StorageService) { }

  async ngOnInit() {
    this.loading = true;
    this.solicitudResponse = await this.storageService.get(SOLICITUD_CONGELAMIENTO_SALDO_RESPONSE);

    if(this.solicitudResponse) this.loading = false;
    
  }

  public goToHome(): void {
    this.router.navigate([ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_BASE,
                          ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_URL,
                          ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_HOME
                        ])
  }

}
